import { loadSettings } from "../pages/SettingsPage";

export async function generateAITag(text) {
  const settings = loadSettings();
  if (!settings.apiKey) return null;

  const isGeminiNative = settings.baseUrl.includes("generativelanguage.googleapis.com");

  let url = settings.baseUrl;
  let headers = { "Content-Type": "application/json" };
  let body = {};

  if (isGeminiNative) {
    headers["x-goog-api-key"] = settings.apiKey;
    body = {
      model: settings.model,
      input: "You are an automatic tag generator for a personal journal. Read the user's journal entry and return exactly ONE word (or very short phrase) that best describes the topic, emotion, or category. Return ONLY the tag text, no quotes or punctuation.\n\nJournal Entry:\n" + text
    };
  } else {
    url = `${settings.baseUrl.replace(/\/$/, '')}/chat/completions`;
    headers["Authorization"] = `Bearer ${settings.apiKey}`;
    body = {
      model: settings.model,
      messages: [
        { role: "system", content: "You are an automatic tag generator for a personal journal. Read the user's journal entry and return exactly ONE word (or very short phrase) that best describes the topic, emotion, or category. Return ONLY the tag text, no quotes or punctuation." },
        { role: "user", content: text }
      ],
      temperature: 0.3,
      max_tokens: 10
    };
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      console.error("AI API Error", await res.text());
      return null;
    }

    const data = await res.json();
    let tag = "";
    
    // Parse Gemini Interactions format
    if (data.steps) {
      const outputStep = data.steps.find(s => s.type === "model_output");
      if (outputStep && outputStep.content) {
        const textContent = outputStep.content.find(c => c.type === "text");
        if (textContent) tag = textContent.text;
      }
    }
    
    // Fallback to standard OpenAI or Gemini formats
    if (!tag) {
      tag = data.output || data.text || (data.candidates && data.candidates[0]?.content?.parts?.[0]?.text) || (data.choices && data.choices[0]?.message?.content) || "";
    }
    
    if (!tag && typeof data === "string") tag = data;
    if (!tag) return null;

    // Sanitize and enforce Postgres varchar(50) limit
    tag = tag.replace(/["'\n]/g, "").trim().substring(0, 30);
    return tag || null;
  } catch (err) {
    console.error("Failed to generate AI tag", err);
    return null;
  }
}
